import { LegalPage } from "../components/LegalPage";
import { SEO } from "../lib/seo";

export const CookiePolicyPage = () => (
  <>
    <SEO
      title="Cookie Policy"
      description="How Humaniti uses cookies and similar technologies."
      path="/cookies"
    />
    <LegalPage
      title="Cookie Policy"
      effectiveDate="2026-04-23"
      intro={
        <p>
          This Cookie Policy describes the cookies and similar technologies Humaniti uses, why we
          use them, and how you can manage them.
        </p>
      }
      sections={[
        {
          id: "what",
          title: "1. What we use",
          body: (
            <ul>
              <li>
                <b>Session cookie / localStorage</b> — stores your sign-in token. Required to use
                the platform.
              </li>
              <li>
                <b>FingerprintJS visitor ID</b> — anti-fraud signal recorded per session and per
                identity.
              </li>
              <li>
                <b>Sentry session ID</b> — error tracking, sample rate 10%.
              </li>
              <li>
                <b>OpenTelemetry trace ID</b> — performance monitoring, sample rate 10%.
              </li>
            </ul>
          ),
        },
        {
          id: "third-party",
          title: "2. Third-party services",
          body: (
            <p>
              We use Sentry (error monitoring), Cloudflare (Turnstile bot gate), Twilio (phone OTP
              delivery), Sumsub (KYC), Mailgun (transactional email). Each receives only the data
              necessary for their function.
            </p>
          ),
        },
        {
          id: "manage",
          title: "3. Managing cookies",
          body: (
            <p>
              You can clear cookies and localStorage at any time in your browser settings. Doing so
              will sign you out.
            </p>
          ),
        },
      ]}
    />
  </>
);
